








import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFreeInputableWrappedObject } from "../objects/IFreeInputableWrappedObject";
import { DisableableMixin } from "../../../system/mixins";
import ToggleFreeInputMethodEditor from "../inputMethodEditors/ToggleFreeInputMethodEditor.vue";

@Component({
  components: {
    ToggleFreeInputMethodEditor,
  }
})
export default class ToggleFreeInputBehaviorEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: IFreeInputableWrappedObject;
}
